import { useEffect } from 'react'
import ReactGA from 'react-ga'
import useSettingsV2 from '../hooks/useSettingsV2'

const GoogleAnalytics = () => {
  const { settings } = useSettingsV2() as any

  useEffect(() => {
    if (!settings || !settings.googleAnalyticsCode) return
    ReactGA.initialize(settings.googleAnalyticsCode)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [settings])

  return null
}

export default GoogleAnalytics
